import { Route, Routes } from 'react-router-dom';
import PrizesTable from './PrizesTable'
import CreateEditPrizeMobile from './CreateEditPrizesMobile'

export const PrizesPage = () => {
  return (
    <Routes>
      <Route index element={<PrizesTable />} />
      <Route path="create" element={<CreateEditPrizeMobile />} />
      <Route path=':id/edit' element={<CreateEditPrizeMobile />} />
    </Routes>
  )
}

export default PrizesPage;